import { render, staticRenderFns } from "./QueryChocostickS.vue?vue&type=template&id=10551db1&"
import script from "./QueryChocostickS.vue?vue&type=script&lang=js&"
export * from "./QueryChocostickS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports